export default "__VITE_ASSET__DZ86NkL7__"